import React, { FC } from 'react'
import { Alert, Col, Grid, Row, Space, Typography } from 'antd'
import { useSdk } from 'hooks/useSdk'
import { useAuth } from 'auth-context'
import { Link } from 'atoms/Link'
import { ApiOutlined, TeamOutlined } from '@ant-design/icons'

const { Title } = Typography

export const Greetings: FC = () => {
  const { user } = useAuth()
  const { xs } = Grid.useBreakpoint()

  const username = user?.name || 'User'

  return (
    <Space
      direction="vertical"
      size="middle"
      style={{
        width: '100%',
        textAlign: xs ? 'center' : 'left',
      }}
    >
      <Title
        level={xs ? 3 : 2}
        style={{
          marginTop: xs ? 0 : 16,
        }}
      >
        👋 Hello{', '}
        {username}!
      </Title>
      <Title level={xs ? 5 : 4}>
        What would you like to do today?
      </Title>
    </Space>
  )
}
